<script setup lang="ts">
import SectionTutorLegal from './legal/SectionTutorLegal.vue'

defineOptions({
  name: 'TutorLegalPage',
})
</script>

<template>
  <SectionTutorLegal />
</template>
